<template>
  <div v-if="api_data.Farmer" id="operationGovSchemeInformation">
    <div class="card rounded-0 card-custom gutter-b">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="card-label">
            <div class="font-weight-bolder">
              {{ $t("Government") }} {{ $t("Scheme") }} {{ $t("No") }} {{ $t("Benefits") }}
            </div>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t("Information") }}</span>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Aadhar Card") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_aadhar_card_number"
                     placeholder="Aadhar Card Number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Election Card") }} {{ $t("Number") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_election_card_number"
                     placeholder="Election Card Number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Ration Card") }} {{ $t("Number") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_ration_card_number"
                     placeholder="Ration Card Number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Antyodaya") }} {{ $t("Ration Card") }} {{ $t("Number") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_antyodaya_number"
                     placeholder="Gov Antyodaya Number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Agratakram") }} {{ $t("Ration Card") }} {{ $t("Number") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_agratakram_number"
                     placeholder="Gov Agratakram Number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("BPL") }} {{ $t("Ration Card") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_bpl_number"
                     placeholder="Gov BPL Number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("APL") }} {{ $t("Ration Card") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_apl_number"
                     placeholder="Gov APL Number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Bank Account") }} {{ $t("Number") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_bank_account_number"
                     placeholder="Bank Account Number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Bank") }} {{ $t("Name") }}</label>
              <input class="form-control form-control-solid"
                     v-model="api_data.Farmer.gov_bank_name"
                     placeholder="Bank Name">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Cast") }} {{ $t("Certificate") }} {{ $t("Number") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_cast_certificate_number"
                     placeholder="Cast Certificate Number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Income") }} {{ $t("Certificate") }} {{ $t("Number") }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.gov_income_certificate_number"
                     placeholder="Income Certificate Number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t("Photo") }}</label>
              <file-to-object
                  :api_data="api_data"
                  v-bind:file_url="api_data.Farmer.gov_photo_file_url"
                  v-bind:file_input_name="'gov_photo_file'"
              ></file-to-object>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t("Cast") }} {{ $t("Proof") }}</label>
              <file-to-object
                  :api_data="api_data"
                  v-bind:file_url="api_data.Farmer.gov_cast_proof_file_url"
                  v-bind:file_input_name="'gov_cast_proof_file'"
              ></file-to-object>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t("Income") }} {{ $t("Proof") }}</label>
              <file-to-object
                  :api_data="api_data"
                  v-bind:file_url="api_data.Farmer.gov_income_proof_file_url"
                  v-bind:file_input_name="'gov_income_proof_file'"
              ></file-to-object>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t("Bank") }}</label>
              <file-to-object
                  :api_data="api_data"
                  v-bind:file_url="api_data.Farmer.gov_bank_file_url"
                  v-bind:file_input_name="'gov_bank_file'"
              ></file-to-object>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t("Ration Card") }}</label>
              <file-to-object
                  :api_data="api_data"
                  v-bind:file_url="api_data.Farmer.gov_ration_card_file_url"
                  v-bind:file_input_name="'gov_ration_card_file'"
              ></file-to-object>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t("Election Card") }}</label>
              <file-to-object
                  :api_data="api_data"
                  v-bind:file_url="api_data.Farmer.gov_election_card_file_url"
                  v-bind:file_input_name="'gov_election_card_file'"
              ></file-to-object>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t("Aadhar Card") }}</label>
              <file-to-object
                  :api_data="api_data"
                  v-bind:file_url="api_data.Farmer.gov_aadhar_card_file_url"
                  v-bind:file_input_name="'gov_aadhar_card_file'"
              ></file-to-object>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <store-short-data-from-json
                :api_data="api_data"
                v-bind:head_title="'Government Scheme Taken'"
                v-bind:data_in_json_input="'gov_scheme_taken'"
            ></store-short-data-from-json>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <store-short-data-from-json
                :api_data="api_data"
                v-bind:head_title="'Government Scheme Not Taken'"
                v-bind:data_in_json_input="'gov_scheme_not_taken'"
            ></store-short-data-from-json>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Surpanch") }} {{ $t("Name") }}</label>
              <input type="text" v-model="api_data.Farmer.gov_surpunch_name"
                     class="form-control"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-grow-1 align-items-center bg-hover-light p-4 rounded">
              <div class="mr-4 flex-shrink-0 text-center" style="width: 40px;">
                <i class="icon-xl fas fa-mobile-alt"></i>
              </div>
              <input type="text" v-model="api_data.Farmer.gov_surpunch_mobile_number"
                     class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("Talati") }} {{ $t("Name") }}</label>
              <input type="text" v-model="api_data.Farmer.gov_talati_name"
                     class="form-control"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex flex-grow-1 align-items-center bg-hover-light p-4 rounded">
              <div class="mr-4 flex-shrink-0 text-center" style="width: 40px;">
                <i class="icon-xl fas fa-mobile-alt"></i>
              </div>
              <input type="text" v-model="api_data.Farmer.gov_talati_mobile_number"
                     class="form-control"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.input-lg {
  font-size: 28px;
}
</style>
<script>
import fileToObject from "../fileToObject";
import StoreShortDataFromJson from "../storeShortDataFromJson";

export default {
  name: 'operation-family-information',
  components: {
    StoreShortDataFromJson,
    fileToObject
  },
  props: {
    api_data: Object,
  },
  data: () => ({
    gov_photo_file_validation_message: false,
    real_base64_file: '',
  }),
  methods: {
    govSchemeTakenDelete(index) {
      this.$props.api_data.Farmer.gov_scheme_taken.splice(index, 1);
    },
    govSchemeNotTakenAdd() {
      this.$props.api_data.Farmer.gov_scheme_not_taken = this.$props.api_data.Farmer.gov_scheme_not_taken || [];
      this.$props.api_data.Farmer.gov_scheme_not_taken.push(
          {
            title: '',
            note: '',
          }
      );
    }
  }
}
</script>
